var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.219,
    height: 30.218,
    viewBox: "0 0 30.219 30.218",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_196",
    "data-name": "Group 196",
    transform: "translate(-1497.174 -64.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_194",
    "data-name": "Group 194",
    transform: "translate(-54.244)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M2331.637,178.289a15.109,15.109,0,1,1-15.109-15.109,15.109,15.109,0,0,1,15.109,15.109",
    transform: "translate(-750 -98.69)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M2317.7,176.227c.248-.279.453-.561.708-.8a3.883,3.883,0,0,1,2.792-1.1,6.45,6.45,0,0,1,1.756.214,3.433,3.433,0,0,1,2.437,2.563,10.726,10.726,0,0,1,.325,2.937c0,2.088-.007,4.174,0,6.261,0,.2-.054.247-.247.245q-1.612-.012-3.226,0c-.189,0-.23-.056-.229-.235q.009-2.979,0-5.958a5.357,5.357,0,0,0-.173-1.479,1.662,1.662,0,0,0-1.829-1.3,2,2,0,0,0-2.1,2,7.456,7.456,0,0,0-.057.931c0,1.932,0,3.864,0,5.795,0,.193-.047.249-.244.247q-1.625-.014-3.249,0c-.174,0-.224-.046-.224-.221q.008-5.735,0-11.472c0-.19.062-.234.241-.232q1.542.011,3.086,0c.189,0,.238.06.233.239-.01.457,0,.915,0,1.371",
    transform: "translate(-750 -98.69)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M2311.8,180.6c0,1.892,0,3.784.005,5.675,0,.211-.052.274-.27.272-1.074-.012-2.149-.01-3.224,0-.172,0-.224-.042-.224-.22q.007-5.745,0-11.491c0-.158.038-.215.206-.214,1.091.007,2.182.009,3.272,0,.209,0,.238.079.237.259q-.008,2.86,0,5.722",
    transform: "translate(-804.244 -98.69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M2312.1,170.822a2.147,2.147,0,1,1-2.143-2.136,2.154,2.154,0,0,1,2.143,2.136",
    transform: "translate(-804.244 -98.69)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.4a2310fed164065771fb82f3bc15b68b.svg";
export { ForwardRef as ReactComponent };